import { formatBytes, notifyError } from "@helpers"

class Image {
    static run(file: File, config: Partial<Interfaces.Config>): boolean {
        if (!config.photo)
            return true
    
        const size = Image.size(file, config.photo.max_size * 1024)
        if (!size.condition) size.effect()
    
        return size.condition
    }

    static size(file: File, max_size: number) {
        return {
            condition: file.size <= max_size,
            effect: () => notifyError("You can't upload images more than " + formatBytes(max_size) + ".")
        }
    }
}

export default {
    image: Image.run
}
